import { render, staticRenderFns } from "./RoundIcon.vue?vue&type=template&id=2a0bba1c&scoped=true&"
import script from "./RoundIcon.vue?vue&type=script&lang=js&"
export * from "./RoundIcon.vue?vue&type=script&lang=js&"
import style0 from "./RoundIcon.vue?vue&type=style&index=0&id=2a0bba1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0bba1c",
  null
  
)

export default component.exports